import { ConfigurationState, ConfigurationStateModel } from 'remarketing-angular-library';

/**
 * Build a tenant specific class name, to be used with NGXS's @Select decorator inside of a component. It provides
 * an alternative to injecting the `tenantName` property or creating a new subscription to the store.
 *
 * Usage:
 * ```ts
 *  class MyComponent {
 *    @Select(tenantClass) tenantClass$: Observable<string>;
 *  }
 * ```
 * ```html
 *  <div [ngClass]="tenantClass$ | async"></div>
 * ```
 */
export function tenantClass(state: { configuration: ConfigurationStateModel }) {
  const { tenantName } = ConfigurationState.configuration(state.configuration);
  return `tenant-${tenantName}`;
}
